import { useState } from 'react';
import { useModal } from '@blueprint/ui';
import {
    OpenModal,
    ModalTypes,
    UseModalManagerReturn
} from './ModalManager.types';
import { MODALS } from './ModalManager';

export const useModalManager = (): UseModalManagerReturn => {
    const [activeModal, setActiveModalState] = useState<ModalTypes>('map');

    const closeTrigger = () => {
        MODALS[activeModal].trackClose();
    };

    const [isModalShowing, openModalInstance, closeModal] = useModal({
        onClose: closeTrigger
    });

    const openModal: OpenModal = (type, triggerOrigin): void => {
        setActiveModalState(type);
        openModalInstance(triggerOrigin);
    };
    return [activeModal, isModalShowing, openModal, closeModal];
};

export default useModalManager;
